import React from "react";
import { Link } from "react-router-dom";
import { SCROLL_TO_PRICING_STATE } from "../../utils/scrollToPricing";
import PostDetailLockIcon from "../PostDetail/PostDetailLockIcon";
import {
  AnalystAlertsGateBody,
  AnalystAlertsGateButton,
  AnalystAlertsGateCard,
  AnalystAlertsGateIcon,
  AnalystAlertsGateText,
  AnalystAlertsGateTitle,
} from "./Analyst.styles";

const COPY = {
  guest: {
    title: "Members only",
    cta: "View membership options",
    to: "/",
    state: SCROLL_TO_PRICING_STATE,
  },
  renew: {
    title: "Renew to read alerts",
    subtitle:
      "Renew your membership to restore full access to analyst alerts.",
    cta: "My billing area",
    to: "/user-profile",
  },
};

const AnalystAlertsGate = ({ variant = "guest", analystName, subtitle }) => {
  const config = COPY[variant] || COPY.guest;
  const text =
    variant === "guest"
      ? `Trade alerts from ${analystName} are available to Bitcoin.live members.`
      : subtitle || config.subtitle;

  return (
    <AnalystAlertsGateCard>
      <AnalystAlertsGateIcon aria-hidden="true">
        <PostDetailLockIcon width={16} height={16} />
      </AnalystAlertsGateIcon>
      <AnalystAlertsGateBody>
        <AnalystAlertsGateTitle>{config.title}</AnalystAlertsGateTitle>
        <AnalystAlertsGateText>{text}</AnalystAlertsGateText>
        <AnalystAlertsGateButton as={Link} to={config.to} state={config.state}>
          {config.cta}
        </AnalystAlertsGateButton>
      </AnalystAlertsGateBody>
    </AnalystAlertsGateCard>
  );
};

export default AnalystAlertsGate;
